import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'ci_unavailability_details';

const validator = () => null;

const vFParams = {
  fieldTitle: 'CI Unavailability Details',
};

const ciUnavailabilityDetails = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { ciUnavailabilityDetails };
